import { orchestrator } from 'satcheljs';
import { dismissItem } from '../actions/dismissItem';
import { dismissAllItems } from '../actions/dismissAllItems';
import { markItemsAsDismissed } from '../service/markItemsAsDismissed';
import type { ActivityFeedItem } from '../service/ActivityFeedItem';
import { getActivityFeedStore } from '../store/store';
import { logUsage } from 'owa-analytics';

orchestrator(dismissItem, ({ itemId }) => {
    const item: ActivityFeedItem = getActivityFeedStore().items.get(itemId);
    logUsage('ActivityItem_ActionClicked', {
        action: 'ActionType.DismissItem',
        itemId: itemId,
        itemType: item.type,
        itemRead: item.isRead,
        itemSeen: item.isSeen,
    });
    markItemsAsDismissed([itemId], false /* dismissAll */);
});

orchestrator(dismissAllItems, ({ itemIds }) => {
    logUsage('ActivityFeed_ActionClicked ', {
        action: 'ActionType.DismissAllItems',
    });
    markItemsAsDismissed(itemIds, true /* dismissAll */);
});
